function halendAddOnToggles() {
  const oldAddOnToggles = document.querySelectorAll(".ombraz-v2pdp__toggle input[type='checkbox']");
  const addOnToggles = document.querySelectorAll(".addon__info-toggle");
  const learnMoreButtons = document.querySelectorAll(".addon__learn-more");

  if (!oldAddOnToggles.length && !addOnToggles.length) return;

  // Remove existing event listeners
  addOnToggles.forEach((toggle) => {
    const checkbox = toggle.querySelector('.addon__checkbox');
    checkbox?.removeEventListener("change", handleNewToggleChange);
  });

  learnMoreButtons.forEach((button) => {
    button?.removeEventListener("click", handleLearnMoreClick);
  });

  if (oldAddOnToggles.length) {
    // Initial state sync
    oldAddOnToggles.forEach((oldCheckbox) => {
      if (oldCheckbox?.checked) {
        const value = oldCheckbox.value;
        syncNewToggleState(value, addOnToggles, true);
      }
    });

    // Handle changes
    addOnToggles.forEach((toggle) => {
      const checkbox = toggle.querySelector('.addon__checkbox');
      if (checkbox) {
        checkbox.addEventListener("change", (e) => handleNewToggleChange(e, oldAddOnToggles));
      }
    });

    // Handle learn more clicks
    learnMoreButtons.forEach((button) => {
      button?.addEventListener("click", handleLearnMoreClick);
    });
  }
}

function syncNewToggleState(value, toggles, checked) {
  const newToggle = Array.from(toggles).find((toggle) => {
    const newCheckbox = toggle.querySelector('.addon__checkbox');
    return newCheckbox && newCheckbox.value === value;
  });

  if (newToggle) {
    const newCheckbox = newToggle.querySelector('.addon__checkbox');
    if (newCheckbox) {
      newCheckbox.checked = checked;
      newCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}

function handleNewToggleChange(event, oldAddOnToggles) {
  const value = event.target.value;
  const oldCheckbox = Array.from(oldAddOnToggles).find(checkbox => checkbox.value === value);

  if (oldCheckbox) {
    oldCheckbox.checked = event.target.checked;
    oldCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

function showOldUIElements() {
  $("body:is([class*='testgroup-a'],[class*='testgroup-b'],[class*='testgroup-c']) :is(.v2pdp__addon-title-wrapper,.ombraz-v2pdp__addon-toggle)").css("display", "block");
}

function handleLearnMoreClick(event) {
  const addonSection = event.target.closest('.addon');
  const checkbox = addonSection.querySelector('.addon__checkbox');
  const value = checkbox.value;

  // Find corresponding old toggle wrapper and dialog opener
  const oldToggleWrapper = Array.from(document.querySelectorAll('.ombraz-v2pdp__toggle-card')).find(toggle => {
    const oldCheckbox = toggle.querySelector('.ombraz-v2pdp__toggle-input');
    return oldCheckbox && oldCheckbox.value === value;
  });

  if (oldToggleWrapper) {
    const dialogOpener = oldToggleWrapper.querySelector('.ombraz-v2pdp__dialog-opener');
    if (dialogOpener) {
      dialogOpener.click();
      showOldUIElements();
    }
  }
}

// Make the functions available globally
window.halendAddOnToggles = halendAddOnToggles;
window.showOldUIElements = showOldUIElements;
